import React from "react";
import { NavLink } from "react-router-dom";
import { Home, BookOpen, Bell, Image, Heart } from "lucide-react";

const ITEMS = [
  { to: "/", label: "Home", icon: Home },
  { to: "/courses", label: "Courses", icon: BookOpen },
  { to: "/notices", label: "News", icon: Bell },
  { to: "/gallery", label: "Gallery", icon: Image },
  { to: "/support", label: "Support", icon: Heart },
];

export default function MobileBottomNav() {
  return (
    <nav
      data-testid="mobile-bottom-nav"
      className="fixed bottom-0 left-0 right-0 z-40 md:hidden bg-white/95 backdrop-blur-xl border-t border-brand-primary/10 pb-safe"
    >
      <div className="grid grid-cols-5 h-16">
        {ITEMS.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            end={to === "/"}
            data-testid={`bnav-${label.toLowerCase()}`}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center gap-1 text-[10px] font-medium transition-colors ${
                isActive ? "text-brand-primary" : "text-brand-muted"
              }`
            }
          >
            {({ isActive }) => (
              <>
                <div
                  className={`w-10 h-7 rounded-full flex items-center justify-center transition-all ${
                    isActive ? "bg-brand-accent" : ""
                  }`}
                >
                  <Icon
                    className={`w-4 h-4 ${
                      isActive ? "text-brand-primary" : "text-brand-muted"
                    }`}
                  />
                </div>
                <span className="tracking-wide">{label}</span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
